<template>
    <div :data-id="terminology.terminologyId"
        :data-testid="'terminologie-card-' + terminology.terminologyId"
        class="terminologie-vignette-container border rounded mb-2 pl-8 pr-8">
        <!-- Line 1: -->
        <div class="vignette-line">
            <!-- Bloc 1: Informations principales (titre, date) -->
            <div class="vignette-bloc vignette-bloc-1">
                <template v-if="terminology.originalLabel && terminology.originalTitle">
                    <p class="terminologie-title">
                        <a class="font-weight-bold primary--text terminologie-title-link"
                            :data-testid="'terminologie-title-link-' + terminology.terminologyId"
                            :href="$searchResultManager.wordPressBaseUrl + '/' + terminology.terminologyId + '/'">{{
                                terminology.originalLabel }}</a>
                    </p>
                    <p class="ma-0 ans-mb">
                        <span class="primary--text">{{ terminology.originalTitle }}</span>
                    </p>
                </template>
                <template v-else>
                        <p class="terminologie-title"><a class="font-weight-bold primary--text terminologie-title-link"
                            :data-testid="'terminologie-title-link-' + terminology.terminologyId"
                            :href="$searchResultManager.wordPressBaseUrl + '/' + terminology.terminologyId + '/'">{{
                                terminology.title
                            }}</a>
                    </p>
                </template>
            </div>

            <!-- Bloc 2: Version et Licence -->
            <div class="vignette-bloc vignette-bloc-2">
                <p class="ma-0 ans-mb">
                    Version :
                    <span class="font-weight-bold black--text">{{ terminology.version }}</span>
                </p>

                <p v-if="terminology.date" class="ma-0 ans-mb">
                    Date de publication :
                    <span class="font-weight-bold black--text">{{ terminology.date }}</span>
                </p>
            </div>

            <!-- Bloc 3: Thème et Personne(s) morale(s) -->
            <div class="vignette-bloc vignette-bloc-3">
                <p class="ma-0 ans-mb">
                    Thème :
                    <span class="font-weight-bold black--text">{{ terminology.theme }}</span>
                </p>
            </div>
        </div>

        <div class="vignette-line pb-1">
            <!-- Boutons d'action -->
            <div class="terminologie-links  terminologie-links-part1" v-if="showConceptsLink">
                <!-- Affichage du bouton concepts liés pour terminologies protégées non-SNOMED -->
                <a v-if="isConnectionNeeded" data-toggle="modal" data-target="#popin-login-required-concepts"
                    :data-testid="'terminologie-concepts-btn-' + terminology.terminologyId"
                    class="terminologie-links-btn concepts-lies-btn btn btn--plain btn--primary btn--icon-before">
                    <i class="fas fa-lock fa-1x pr-1"></i>Concepts liés
                </a>





                <!-- Affichage du bouton concepts liés pour autres cas -->
                <a v-else :href="conceptsUrl"
                    :data-testid="'terminologie-concepts-btn-' + terminology.terminologyId"
                    class="terminologie-links-btn concepts-lies-btn btn btn--plain btn--primary btn--icon-before">
                    <i v-if="showSnomedConceptLock" class="fas fa-lock fa-1x pr-1"></i>Concepts liés
                </a>

                <!-- Affichage du bouton sparna -->
                <template v-if="isTerminologySparna">
                    <template v-if="isConnectionNeeded">
                        <a data-toggle="modal" data-target="#popin-login-required-concepts"
                            :data-testid="'terminologie-sparnatural-btn-' + terminology.terminologyId + '-locked'"
                            class="terminologie-links-btn btn btn--plain btn--primary"><i
                                class="fas fa-lock fa-1x pr-1"></i>Sparnatural</a>
                    </template>
                    <template v-else>
                        <a :href="$searchResultManager.wordPressBaseUrl + '/' + terminology.terminologyId + '/sparnatural'"
                            :data-testid="'terminologie-sparnatural-btn-' + terminology.terminologyId + '-unlocked'"
                            class="terminologie-links-btn btn btn--plain btn--primary">Sparnatural</a>
                    </template>
                </template>

            </div>

            <div class="terminologie-links terminologie-links-part2">
                <template v-if="isTerminologyAns">
                    <!-- Bouton de téléchargement du zip pour terminologies protégées -->
                    <a v-if="isConnectionNeeded" type="button"
                        :data-testid="'terminologie-download-zip-btn-' + terminology.terminologyId + '-login-required'"
                        class="terminologie-links-btn terminologie-zip-btn btn btn--style1 btn--white border mr-1 file-link"
                        data-toggle="modal" data-target="#popin-login-required-zip">
                        <i class="fas fa-lock fa-1x pr-1"></i>Télécharger zip
                    </a>
                    <!-- Bouton de téléchargement du zip pour SNOMED CT sans accès -->
                    <a v-else-if="showSnomedConceptLock"
                        :data-testid="'terminologie-download-zip-btn-' + terminology.terminologyId + '-locked'"
                        class="terminologie-links-btn terminologie-zip-btn terminology-load-licence btn btn--style1 btn--white border mr-1 file-link"
                        :data-terminology-licence="terminology.licence.label"
                        :data-terminology-id="terminology.terminologyId"
                        :data-terminology-version="terminology.version">
                        <i class="fas fa-lock fa-1x pr-1"></i>Télécharger zip
                    </a>
                    <!-- Bouton de téléchargement du zip pour autres terminologies ANS -->
                    <a v-else
                        :data-testid="'terminologie-download-zip-btn-' + terminology.terminologyId + '-unlocked'"
                        class="terminologie-links-btn terminologie-zip-btn terminology-load-licence btn btn--style1 btn--white border mr-1 file-link"
                        :data-terminology-licence="terminology.licence.label"
                        :data-terminology-id="terminology.terminologyId"
                        :data-terminology-version="terminology.version">
                        Télécharger zip
                    </a>
                </template>
                <!-- bouton Détail terminologie -->
                <a :href="$searchResultManager.wordPressBaseUrl + '/' + terminology.terminologyId + '/'"
                    :data-testid="'terminologie-detail-btn-' + terminology.terminologyId"
                    class="terminologie-links-btn btn btn--style1 btn--white border mr-1">Détail terminologie</a>
            </div>
        </div>

    </div>
</template>

<script>
import Snomed from "../snomed";
import TokenService from '../../../common/token.service';

export default {
    name: 'TerminologieVignette',
    props: {
        terminology: {
            type: Object,
            required: true
        },
        user: {
            type: Object,
            default: undefined
        }
    },

    data() {
        return {
            Snomed: Snomed
        };
    },

    computed: {
        /**
         * Indique si le lien vers les concepts doit être affiché
         * @return {boolean}
         */
        showConceptsLink() {
            return !!(this.terminology.publisher == "ANS"
                && this.terminology.mediaType
                && this.terminology.mediaType.some(m => m.toLowerCase() === 'owl'));
        },

        /**
         * Indique si la terminologie est protégée (nécessite une connexion utilisateur)
         * @return {boolean}
         */
        isConnectionNeeded() {
            const forProtected = !!this.terminology?.forProtected;
            const snomedCT = !!this.terminology?.snomedCT;
            const isUserLoggedIn = !!this.$searchResultManager?.isUserLoggedIn;
            const isConnectionNeeded = forProtected && !snomedCT && !isUserLoggedIn;
            return isConnectionNeeded;
        },


        /**
         * Indique si la terminologie est une terminologie ANS
         * @return {boolean}
         */
        isTerminologyAns() {
            return this.terminology.publisher == "ANS";
        },


        /**
         * Indique si la terminologie est une terminologie SPARNA
         * @return {boolean}
         */
        isTerminologySparna() {
            return this.$searchResultManager.sparnaTerminologies.includes(this.terminology.terminologyId);
        },


        /**
         * Indique si la terminologie est une terminologie SNOMED CT
         * @return {boolean}
         */
        isTerminologySnomed() {
            const rawSnomedCT = this.terminology?.snomedCT;
            const isSnomed = rawSnomedCT || false;
            return isSnomed;
        },

        /**
         * URL vers la page des concepts liés à la terminologie
         * @return {string}
         */
        conceptsUrl() {
            return this.$searchResultManager.wordPressBaseUrl + '/' + this.$searchResultManager.conceptsCatalogSlug + '/' + this.terminology.terminologyId + '/?treeViewType=complete';
        },

        connectedUser() {
            if (this.user) {
                return this.user;
            }

            if (!this.$searchResultManager.isUserLoggedIn
                || !this.$searchResultManager
                || !this.$searchResultManager.tokens
                || !this.$searchResultManager.tokens.accessToken) {
                return undefined;
            }

            try {
                const parsedUser = TokenService.parseJwt(this.$searchResultManager.tokens.accessToken);
                return parsedUser;
            } catch {
                return undefined;
            }
        },

        hasValidSnomedUserLicence() {
            if (!this.$searchResultManager.isUserLoggedIn
                || !this.connectedUser
                || !this.terminology
                || !Array.isArray(this.terminology.licences)) {
                return false;
            }

            return Snomed.checkIfUserHasSnomedLicenceOfTheSnomedTermino(this.terminology, this.connectedUser);
        },

        showSnomedConceptLock() {
            const isSnomed = this.isTerminologySnomed;
            const hasBrowserLicence = Snomed.checkIfSnomedBrowerLicenceValid();
            const hasUserLicence = this.hasValidSnomedUserLicence;
            const shouldShowLock = isSnomed
                && !hasBrowserLicence
                && !hasUserLicence;
            return shouldShowLock;
        }
    },

    methods: {
        /**
         * Extrait le nom de fichier d'un chemin donné.
         * @param path 
         */
        extractFileName(path) {
            if (!path) return '';
            let splittedPath = path.split('/');
            return splittedPath[splittedPath.length - 1];
        },

    }
}
</script>

<style lang="scss" scoped>
$ans-main-color-blue: var(--v-primary-base);

.terminologie-title {
    margin-bottom: 7.5px;
}

.terminologie-title-link {
    text-decoration: none;

    &:hover {
        text-decoration: underline;
    }
}

.terminologie-links-btn {
    margin-right: 0.5rem;
    margin-left: 0.5rem;
}

.terminologie-links {
    display: flex;
    flex-direction: row;
    align-items: center;
    flex: 1;
}

.terminologie-zip-btn {
    width: 250px;
}

.concepts-lies-btn {
    width: 180px;
}

.terminologie-links-part1 {
    flex-grow: 1;
}

.terminologie-links-part2 {
    justify-content: flex-end;
    flex-grow: 2;
}

.terminologie-vignette-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    overflow: hidden;
    background-color: #fff;
    margin-bottom: 1rem;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    border-radius: 1.4rem !important;

    &:hover {
        border-color: var(--v-primary-base);
    }
}

.vignette-line {
    flex: 1;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    border-radius: 0.5rem;
    overflow: hidden;
    background-color: #fff;
    margin-top: 1rem;
    width: 100%;
    margin-left: auto;
    margin-right: auto;

}

.vignette-bloc {
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    height: 100%;
}

.vignette-bloc-1 {
    flex: 1;
}

.vignette-bloc-2,
.vignette-bloc-3 {
    flex: 1;
}

.ans-mb {
    margin-bottom: 0.75rem !important;
}

.ftz-13 {
    font-size: 13px;
}


// Responsive: empiler verticalement sur mobile
@media (max-width: 1300px) {
    .terminologie-links-btn {
        width: 100%;
        margin-bottom: 1rem;
    }

    .vignette-line {
        flex-direction: column;
        width: 90%;
    }



    .terminologie-vignette-container {
        flex-direction: column;
        width: 90%;
    }

    .vignette-bloc {
        &:not(:last-child)::after {
            display: none;
        }

        &:not(:last-child) {
            border-bottom: 1px solid #dadada;
            padding-bottom: 1rem;
        }

        &:not(:first-child) {
            padding-top: 1rem;
        }
    }

    .ans-mb {
        margin-bottom: 0.5rem !important;
    }
}


// Responsive: empiler verticalement sur mobile
@media (max-width: 400px) {
    .terminologie-links {
        flex-direction: column !important;
    }

    .vignette-line {
        flex-direction: column;
        width: 100%;
    }

    .terminologie-vignette-container {
        flex-direction: column;
        width: 100%;
    }
}
</style>
